import { Box, Flex, Image, Text } from '@chakra-ui/react';
import ScrollingText from 'components/NowPlaying/ScrollingText';
import useNowPlaying from 'hooks/use-now-playing';
import ohanaSing from 'assets/images/OhanaSing.png';

const MinimalMark2NowPlaying = () => {
  const { songName, singer } = useNowPlaying();

  return (
    <Flex
      fontFamily="'Kosugi Maru', sans-serif"
      w="320px"
      h="80px"
      p="8px"
      gap="12px"
      align="center"
      bg="#fffcfa"
      border="1px solid #edcbbb"
      borderRadius="12px"
      overflow="hidden"
    >
      <Flex
        boxSize="62px"
        flexShrink={0}
        align="center"
        justify="center"
        bg="linear-gradient(145deg, #fff4ef, #fce6e8)"
        borderRadius="full"
      >
        <Image
          src={ohanaSing}
          boxSize="62px"
          objectFit="contain"
          alt="Hana singing"
        />
      </Flex>
      <Box flex={1} minW={0}>
        <Flex align="center" gap="6px" mb="3px">
          <Box boxSize="4px" borderRadius="full" bg="#d98f9c" aria-hidden="true" />
          <Text
            fontSize="9px"
            lineHeight="13px"
            letterSpacing="1.4px"
            color="#ac6175"
            whiteSpace="nowrap"
          >
            {songName ? 'Now playing' : 'Ready to sing'}
          </Text>
        </Flex>
        <ScrollingText color="#78483e" fontSize="16px" lineHeight="23px" fontWeight="400">
          {songName || 'Waiting for a song'}
        </ScrollingText>
        {singer && (
          <ScrollingText color="#9b6c65" fontSize="12px" lineHeight="18px" fontWeight="400">
            {singer}
          </ScrollingText>
        )}
      </Box>
    </Flex>
  );
};

export default MinimalMark2NowPlaying;
